import { render } from "./UpdateOldAccount.vue?vue&type=template&id=cf54504a&scoped=true"
import script from "./UpdateOldAccount.vue?vue&type=script&lang=js"
export * from "./UpdateOldAccount.vue?vue&type=script&lang=js"

import "./UpdateOldAccount.vue?vue&type=style&index=0&id=cf54504a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf54504a"]])

export default __exports__